import t from"@any-touch/tap";function e(e){e.use(t,{name:"doubletap",tapTimes:2});const a=e.get("doubletap");let o;return e.beforeEach(((t,e)=>{"tap"===t?(clearTimeout(o),o=setTimeout((()=>{[0,2].includes(a.state)&&e()}),300)):e()})),a}export{e as default};
//# sourceMappingURL=index.es.js.map
